import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useAccount } from 'wagmi';
import { toast } from "react-toastify";
import { useTokenInfo } from '../../../../hooks/useTokenInfo';
import { useTokenAllowance } from '../../../../hooks/useTokenAllowance';
import { useTopUpRewards } from '../hooks/useTopUpRewards';
import Loader from '../../../../shared/Loader';
import TokenToDollor from '../../../../shared/TokenToDollor';
import { ApiUrl } from '../../../../utils/ApiUrl';
import { usePoolUpdate } from '../hooks/usePoolUpdate';
import { useTheme } from '../../../../hooks/ThemeProvider';
import { EXPLORER_URL } from '../../../../utils/constant';
function TopUpRewardsModals({ show, onHide, poolData, fetchRootPools }) {
    const { updateRewardAmount, isUpdating } = usePoolUpdate();
    const { address: account } = useAccount();
    const { balance, balanceWei, symbol, decimals, isLoading: isLoadingToken } = useTokenInfo(poolData?.rewardToken);
    const { ensureAllowance, isApprovingToken } = useTokenAllowance();
    const { topUpRewards, estimateTopUpGas, isTopUpInProgress, isEstimatingGas } = useTopUpRewards();
    // console.log("poolDatasadfasdf", poolData);
    const [currentStep, setCurrentStep] = useState(1);
    const [topUpAmount, setTopUpAmount] = useState('');
    const [gasEstimate, setGasEstimate] = useState(null);
    const [transactionHash, setTransactionHash] = useState('');
 const { theme } = useTheme();
    const handleClose = () => {
        setCurrentStep(1);
        setTopUpAmount('');
        setGasEstimate(null);
        setTransactionHash('');
        onHide();
    };

    const validateAmount = () => {
        if (!topUpAmount || parseFloat(topUpAmount) <= 0) {
            toast.error("Please enter a valid amount");
            return false;
        }

        const amount = parseFloat(topUpAmount);
        const userBalance = parseFloat(balance);

        if (amount > userBalance) {
            toast.error(`Insufficient balance. You have ${balance} ${symbol}`);
            return false;
        }

        return true;
    };

    const handleContinue = async () => {
        if (!validateAmount()) return;

        try {
            const estimate = await estimateTopUpGas(poolData?.contractAddress, topUpAmount, decimals);
            setGasEstimate(estimate);
            setCurrentStep(2);
        } catch (error) {
            console.error("Gas estimation error:", error);
            toast.error("Failed to estimate gas fees. Please try again.");
        }
    };

    const updatePoolRewards = async (newRewardAmount) => {
        try {
            const accessToken = localStorage.getItem('accessToken');

            if (!accessToken) {
                throw new Error("Access token not found. Please login again.");
            }

            const totalRewardAmount = parseFloat(poolData?.rewardAmount || 0) + parseFloat(newRewardAmount);

            const payload = {
                rewardAmount: totalRewardAmount,
                rootPoolId: poolData?._id
            };

            const response = await fetch(`${ApiUrl}/pool`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`API error: ${response.statusText}`);
            }

            const data = await response.json();
            // console.log("Pool updated successfully:", data);
            return data;
        } catch (error) {
            console.error("Error updating pool rewards:", error);
            throw error;
        }
    };

    const handleConfirm = async () => {
        if (!account) {
            toast.error("Please connect your wallet");
            return;
        }

        try {
            await ensureAllowance(
                poolData?.rewardToken,
                poolData?.contractAddress,
                topUpAmount
            );

            const result = await topUpRewards(poolData?.contractAddress, topUpAmount, decimals);

            // Update pool rewards via API

            // Simple one-liner API call
            await updateRewardAmount(poolData?._id, topUpAmount, poolData?.rewardAmount);


            fetchRootPools();
            setTransactionHash(result.hash);
            setCurrentStep(3);

        } catch (error) {
            console.error("Top-up error:", error);
            if (error.message?.includes("User rejected")) {
                toast.error("Transaction rejected by user");
            } else {
                toast.error("Failed to top-up rewards. Please try again.");
            }
        }
    };

    const handleFinalClose = () => {
        handleClose();
    };

    const truncateHash = (hash) => {
        if (!hash) return "0x74rhiw4rf38u...5r2";
        return `${hash.slice(0, 10)}...${hash.slice(-3)}`;
    };

    const isProcessing = isApprovingToken || isTopUpInProgress || isEstimatingGas;
    const getLoadingText = () => {
        if (isApprovingToken) return 'Approving Token...';
        if (isTopUpInProgress) return 'Processing Top-Up...';
        if (isEstimatingGas) return 'Estimating Gas Fees...';
        if (isLoadingToken) return 'Loading Token Info...';
        return 'Loading...';
    };
    // console.log(isProcessing, 'isProcessing');

    return (
        <>
            {isProcessing && <Loader loadingText={getLoadingText()} />}
            {/* Step 1: Top Up Rewards Modal */}
            <Modal
                className="stakingmodal"
                show={show && currentStep === 1 && !isProcessing}
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Top Up Rewards</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="reward_modal">
                        <div className="amount">
                            <p>Top Up Amount</p>
                            <span className="greeyyy">
                                Balance: <span className="whitetext">
                                    {isLoadingToken ? "Loading..." : `${balance} ${symbol}`}
                                </span>
                            </span>
                        </div>
                        <div className="inpuuut">
                            <input
                                placeholder="0.00"
                                type="number"
                                id="fname"
                                name="fname"
                                value={topUpAmount}
                                onChange={(e) => setTopUpAmount(e.target.value)}
                                disabled={isProcessing}
                                min="0"
                                step="any"
                            />
                            <div className="oasis_text">
                                <h5>{symbol || 'OASIS'}</h5>
                            </div>
                        </div>
                    </div>
                    <div className="buton_modal_div">
                        <button
                            onClick={handleContinue}
                            disabled={isProcessing}
                        >
                            {isEstimatingGas ? "Estimating..." : "Continue"}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Step 2: Finalize Top Up Rewards Modal */}
            <Modal
                className="stakingmodal"
                show={show && currentStep === 2 && !isProcessing}
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Finalize Top Up Rewards</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal_share">
                        <div className="inner_type">
                            <div className="one_modal">
                                <p>Top Up Amount</p>
                                <h3>{topUpAmount} {symbol || 'OASIS'}</h3>
                                <p className="numbers">~$<TokenToDollor tokenAddress={poolData?.rewardToken} tokenAmount={topUpAmount || '0'} /></p>
                            </div>
                            <div className="main_lock">
                                <div className="inner_lock">
                                    <p>Gas Fees</p>
                                    <span>
                                        <TokenToDollor tokenAddress='' tokenAmount={gasEstimate?.totalGasCostETHFormatted || '0'} />
                                        ({gasEstimate?.totalGasCostETHFormatted || '0'} ETH)
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="buton_modal_div">
                            <button
                                onClick={handleConfirm}
                                disabled={isProcessing}
                            >
                                {isApprovingToken
                                    ? "Approving Token..."
                                    : isTopUpInProgress
                                        ? "Processing..."
                                        : "Confirm"}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Step 3: Top Up Success Modal */}
            <Modal
                className="stakingmodal"
                show={show && currentStep === 3 && !isProcessing}
                onHide={handleFinalClose}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="succes_modal">
                        <div className="top_success">
                            <img src="/assets/tick.svg" alt="success" />
                            <h3>Top-Up Successful</h3>
                            <p>Your balance has been updated with the new amount.</p>
                        </div>
                        <div className="hash_div">
                            <div>
                                <p>Transaction Hash</p>
                                <span>{truncateHash(transactionHash)}</span>
                            </div>
                            <button
                                onClick={() => window.open(`${EXPLORER_URL}${transactionHash}`, '_blank')}
                            >
                                      {theme === 'dark' ? (
                            <img src="/assets/whitetab.svg" alt="view" />
                    ) : (
                     <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
  <path d="M12.25 8.08333V11.5833C12.25 11.8928 12.1271 12.1895 11.9083 12.4083C11.6895 12.6271 11.3928 12.75 11.0833 12.75H2.91667C2.60725 12.75 2.3105 12.6271 2.09171 12.4083C1.87292 12.1895 1.75 11.8928 1.75 11.5833V3.41667C1.75 3.10725 1.87292 2.8105 2.09171 2.59171C2.3105 2.37292 2.60725 2.25 2.91667 2.25H6.41667" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.25 2.25L7 7.5" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.75 2.25H12.25V5.75" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                    )}

                                View
                            </button>
                        </div>
                        <div className="buton_modal_div">
                            <button onClick={handleFinalClose}>Close</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default TopUpRewardsModals;